import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import Row from '../common/Row';
// eslint-disable-next-line import/no-cycle
import { TableContext } from '../../CustomTable';
import classes from './BodyRow.module.scss';

export default function BodyRow({ row, children }) {
  const ctx = useContext(TableContext);
  return (
    <div
      role="presentation"
      onClick={() => {
        if (ctx.rowClickHandler) ctx.rowClickHandler(row.Id);
      }}
      className={ctx.rowClickHandler ? classes.withRowClick : ''}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...ctx.lineStyles
      }}
    >
      <Row withLines={ctx.withLines.body}>{children}</Row>
    </div>
  );
}
